import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from '@24i/nxg-core-router/src/NextRouter';
import { useTheme } from '@24i/nxg-sdk-higgs';
import { View } from '@24i/nxg-sdk-quarks';
import { overridable } from '@24i/nxg-sdk-gluons/src/context/ComponentOverrides';
import { NavScreenConfigWeb } from '@24i/nxg-sdk-gluons/src/clients/AppNavigationClient';
import { getBottomTabBarStyles } from './styles/index.web';
import { TopBarMenuItem } from '../../../components/MenuItem';
import { useMenuItemPress } from '../../utils';

// TODO: Type
const BottomTabBar = ({ styles: getStyles = getBottomTabBarStyles, menuItems = [] }: any) => {
    const router = useRouter();
    const { theme } = useTheme();
    const { t } = useTranslation(['sott']);
    const onPress = useMenuItemPress();

    const styles = getStyles(theme);

    const getMenuItemComponent = (menuItem: NavScreenConfigWeb, index) => {
        const { icon, menuTitle, name, optionsWeb: options } = menuItem;

        let titleLabel;
        if (options?.showTitle !== false) {
            if (name === 'searching') {
                titleLabel = t(`menu.Search`);
            } else {
                titleLabel = t(`menu.${menuTitle}`);
            }
        } else {
            titleLabel = '';
        }

        return (
            <View key={`bottommenu-link-${name}`}>
                <TopBarMenuItem
                    key={`bottommenu-${menuTitle}`}
                    title={titleLabel}
                    icon={icon}
                    index={index}
                    active={router.asPath.includes(name)}
                    spatial
                    onPress={() => onPress(menuItem)}
                />
            </View>
        );
    };

    return (
        <View style={styles.menuContainer}>
            <View style={styles.sectionContainer}>
                <View style={styles.section}>{menuItems.map(getMenuItemComponent)}</View>
            </View>
        </View>
    );
};

export default overridable(BottomTabBar, 'BottomTabBar');
